import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";

import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../../Base/Services/ToastService";

import { getTypesCategoria } from "../../../../Base/API/Global/Types/TypeRequest"; 
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { getPersonal } from "../../../../API/RRHH/Personal/PersonalRequests";
import { EditarMotorista, GuardarMotorista } from "../../../../API/Global/Motoristas/MotoristasRequest";


const MotoristasCRUD = ({
  showDialog,
  selected,
  setShowDialog,
  getInfo,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [estados, setEstados] = useState([]);

  const initialValues = {
    IdMotorista: -1,
    IdEstado: selected?.IdEstado ? selected?.IdEstado : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
 
    const tiposTempo = await getTypesCategoria('Licencia')
    setTipos(tiposTempo)

    const personalTempo = await getPersonal()
    setPersonal(personalTempo)

    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo)


    setValues({
        ...selected,
        IdTipoLicencia: selected?.IdTipoLicencia ? selected?.IdTipoLicencia : null,
        Type: selected?.TipoLicencia ? selected?.TipoLicencia : '',
        IdEstado: selected?.IdEstado ? selected?.IdEstado : 5,
        StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
        IdPersonal: selected?.IdPersonal ? selected?.IdPersonal : null,
        NombreConcatenado: selected?.NombreConcatenado ? selected?.NombreConcatenado : ''
    })

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Nombre) {
      error.Nombre = true;
      error.error = true;
    }
    if (!values.Apellido) {
        error.Apellido = true;
        error.error = true;
    }
    if (!values.Identificacion) {
        error.Identificacion = true;
        error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdEstado) {
        error.StatusName = true;
        error.error = true;
    }
    if (!values.Type?.IdType && !values?.IdTipoLicencia) {
        error.Type = true;
        error.error = true;
    }


    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){

        const Datos = {
            IdMotorista: values?.IdMotorista ? values?.IdMotorista : -100,
            Nombre: values?.Nombre,
            Apellido: values?.Apellido,
            Identificacion: values?.Identificacion,
            IdEstado: values?.StatusName?.IdStatus || values?.IdEstado,
            IdPersonal: values?.NombreConcatenado?.IdPersonal || values?.IdPersonal,
            IdTipoLicencia: values?.Type?.IdType || values?.IdTipoLicencia,
            Comentario: values?.Comentario,
        }

        console.log(Datos)


        setLoading(true)
        if(Datos?.IdMotorista > 0){
            const respuesta = await EditarMotorista(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }else{
            const respuesta = await GuardarMotorista(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
        getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Motorista" : "Editar Motorista";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Nombre"
                    value={values.Nombre}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Nombre ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nombre">Nombre</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Apellido"
                    value={values.Apellido}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Apellido ? "p-invalid" : ""}
                  />
                  <label htmlFor="Apellido">Apellido</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Identificacion"
                    value={values.Identificacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Identificacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Identificacion">Identificación</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StatusName"}
                    value={values.StatusName}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    className={error.StatusName ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"NombreConcatenado"}
                    value={values.NombreConcatenado}
                    items={personal}
                    field={"NombreConcatenado"}
                    label={"Personal"}
                    handleInputChange={handleInputChange}
                    className={error.NombreConcatenado ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Type"}
                    value={values.Type}
                    items={tipos}
                    field={"Type"}
                    label={"Licencia"}
                    handleInputChange={handleInputChange}
                    className={error.Type ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <InputText
                        name="Comentario"
                        value={values.Comentario}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.Comentario ? "p-invalid" : ""}
                    />
                    <label htmlFor="Comentario">Comentario</label>
                    </span>
                </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MotoristasCRUD;
